'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validation;

var _immutable = require('immutable');

var _UserInfoActionTypes = require('../actionTypes/UserInfoActionTypes');

var _ValidateActionTypes = require('../actionTypes/ValidateActionTypes');

var _RegisteredLeadsActionTypes = require('../actionTypes/RegisteredLeadsActionTypes');

function parseFailedResponse(response) {
  var status = response.status,
      responseJSON = response.responseJSON;

  var statusMessage = responseJSON ? responseJSON.status : null;
  if (!statusMessage || statusMessage === 'bad request') {
    statusMessage = 'error';
  }

  return {
    statusCode: status,
    statusMessage: statusMessage,
    requestId: responseJSON ? responseJSON.requestId : null
  };
}

var initialState = new _immutable.Map({
  statusCode: null,
  userCreated: null,
  userCompleted: null,
  userCanLogin: null,
  statusMessage: null,
  requestId: null,
  firstNameIsValid: false,
  lastNameIsValid: false,
  emailIsTaken: false,
  emailIsValid: false,
  emailIsInvalid: false,
  emailIsForbidden: false,
  passwordIsValid: false,
  domainIsValid: null,
  doesntHaveDomain: false,
  currentlyValidating: false,
  existingUserCanLogin: false,
  emailDomainFormSubmitted: false,
  domainIsAvailable: true,
  claimedDomainsMap: (0, _immutable.Map)()
});

function validation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    // We only want to change the state of 'existingUserCanLogin' when a valid response is returned.
    case _ValidateActionTypes.EMAIL_VALIDATED:
      return state.merge(payload).set('currentlyValidating', false).set('existingUserCanLogin', payload.statusCode ? payload.emailIsTaken && payload.userCanLogin : state.get('existingUserCanLogin'));

    case _ValidateActionTypes.PASSWORD_VALIDATED:
      return state.merge(payload).set('currentlyValidating', false);

    case _UserInfoActionTypes.STORE_USERDATA:
      if (payload.domain) {
        return state.merge({
          statusCode: null,
          statusMessage: null,
          domainIsValid: null,
          emailIsForbidden: false
        });
      }
      return state;

    case _ValidateActionTypes.DOMAIN_VALIDATED:
      return state.merge(payload).set('currentlyValidating', false);

    case _ValidateActionTypes.VALIDATE_SUCCEEDED:
      return state.merge(payload).set('currentlyValidating', false).set('statusCode', 200);

    case _ValidateActionTypes.VALIDATE_ATTEMPTED:
      return state.merge({
        statusCode: null,
        statusMessage: null,
        currentlyValidating: true,
        emailIsForbidden: false
      });

    case _ValidateActionTypes.VALIDATE_FAILED:
      return state.merge(parseFailedResponse(payload)).set('currentlyValidating', false);

    case _ValidateActionTypes.EMAIL_DOMAIN_FORM_SUBMITTED:
      return state.set('emailDomainFormSubmitted', true);

    case _RegisteredLeadsActionTypes.REQUESTED_REGISTER_NEW_LEAD_FAILED:
      return state.set('claimedDomainsMap', state.get('claimedDomainsMap').set(payload.domain, payload.failureToken));

    case _ValidateActionTypes.FIRST_NAME_VALIDATED:
    case _ValidateActionTypes.LAST_NAME_VALIDATED:
      return state.merge(payload);

    default:
      return state;
  }
}
module.exports = exports['default'];